(function () {
    const burgerMenu = document.querySelector('.menu-box-btn');
    if (!burgerMenu) return;

    const overlay = document.querySelector('.diu-neos-structure-header__mobile-overlay');
    const darkLayer = document.querySelector('.diu-neos-structure-header__dark-layer');
    const bodyToggle = document.querySelector('body');
    burgerMenu.onclick = function () {
        burgerMenu.classList.toggle('js-active');
        burgerMenu.classList.toggle('js-not-active');
        overlay.classList.toggle('js-active');
        darkLayer.classList.toggle('js-active');
        bodyToggle.classList.toggle('js-fixed');
    };
})();
